export default {"src":"/_next/static/media/disc-types.028b20e1.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};